import { Component, OnInit, ViewChild, Input, ElementRef } from '@angular/core';
import { Location } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';
import { AuthService } from 'src/app/services/auth/auth.service';
import { ThemeService } from 'src/app/services/theme/theme.service';
import { DashboardService } from 'src/app/services/dashboard/dashboard.service';

@Component({
    selector: 'navbar-cmp',
    templateUrl: 'navbar.component.html',
    styleUrls: ['navbar.component.scss'],
    standalone: false
})
export class NavbarComponent implements OnInit {
    location: Location;

    @Input() userName: string = '';
    @Input() userEmail: string = '';
    @Input() userRole: string = '';

    public isCollapsed = true;
    @ViewChild("navbar-cmp", { static: false }) button!: ElementRef;

    constructor(
        location: Location,
        private translate: TranslateService,
        private _auth: AuthService,
        private _theme: ThemeService,
        private _dashboardService: DashboardService
    ) {
        this.location = location;
    }

    ngOnInit(): void {
        setTimeout(() => {
            document.getElementById('sidebar-toggle')?.classList.remove('d-none');
        }, 1000);
    }

    toggleTheme(): void {
        if (this._theme.isDarkTheme()) {
            this._theme.setLightTheme();
        } else {
            this._theme.setDarkTheme();
        }
    }

    changeLang(lang: string): void {
        this.translate.use(lang);
    }

    logout(): void {
        this._auth.logout();
    }

    home(): void {
        this._dashboardService.setUpdateSidebar();
    }
}
